var map = {
	"./Alksnis1.mp3": 31121,
	"./Alksnis2.mp3": 58686,
	"./Alksnis3.mp3": 43427,
	"./Berzs1.mp3": 69840,
	"./Berzs2-1.mp3": 1433,
	"./Berzs2-2.mp3": 67718,
	"./Berzs2-4.mp3": 32824,
	"./Berzs3-1.mp3": 61896,
	"./Berzs3-2.mp3": 97151,
	"./Berzs3-3.mp3": 4538,
	"./Eglitis1.mp3": 55243,
	"./Jasis1.mp3": 73424,
	"./Lapa1.mp3": 8492,
	"./Presnikovs1.mp3": 31806,
	"./Presnikovs2-1.mp3": 95339,
	"./Presnikovs2.mp3": 4241,
	"./Presnikovs3.mp3": 88908,
	"./Raiskums1.mp3": 36325,
	"./Ziemelis1.mp3": 4714,
	"./Ziemelis2-1.mp3": 33823,
	"./Ziemelis2.mp3": 65821,
	"./Ziemelis3.mp3": 53304,
	"./Ziemelis4-1.mp3": 63445,
	"./Ziemelis4.mp3": 27307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36827;